
import { defineComponent, PropType } from 'vue'
import dependencyMixin from '~/mixins/dependencyMixin'
import {
  VulnerabilityOccurrence,
  VulnerabilityOccurrenceFixability,
  VulnerabilityOccurrenceReachability
} from '~/types/types'
import { severityIconMap } from '~/utils/dependencies'
import { extractHashId } from '~/utils/hashId'

export default defineComponent({
  name: 'VulnerabilityListItem',
  mixins: [dependencyMixin],
  data() {
    return {
      VulnerabilityOccurrenceFixability,
      VulnerabilityOccurrenceReachability,
      severityIconMap,
      preloadTimeout: null as ReturnType<typeof setTimeout> | null
    }
  },
  props: {
    item: {
      type: Object as PropType<VulnerabilityOccurrence>,
      required: true
    },
    targetId: {
      type: String,
      required: true
    }
  },
  methods: {
    extractHashId,
    async preloadOccurrence(id: string) {
      await this.fetchOccurrence(id)
    },
    async onEnter() {
      this.preloadTimeout = setTimeout(() => {
        this.preloadOccurrence(this.item.id)
      }, 1000)
    },
    onLeave() {
      if (this.preloadTimeout) {
        clearTimeout(this.preloadTimeout)
      }
    },
    handleFixClick(item: VulnerabilityOccurrence) {
      this.$emit('fix-btn-click', item)
    }
  },
  beforeDestroy() {
    if (this.preloadTimeout) {
      clearTimeout(this.preloadTimeout)
    }
  }
})
